import * as d3 from 'd3';

let registry = {};

export default class Chart {
    constructor(dom, width, height, padding) {
        this.initialized = false;
        this.padding = padding;
        this.plugins = [];
        this.width = width;
        this.height = height;
        this.padding = padding;
        this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        this.dom = dom;
        this.dom.classList.add('chart');
        this.selector = 'chart_' + Math.floor((Math.random() * (9999999 - 1000000) + 1000000));
        this.dom.classList.add(this.selector);
        this.dom.setAttribute('id', this.selector);
        this.dom.appendChild(this.svg);

        this.x = d3.scaleLinear().rangeRound([0, width]);
        this.y = d3.scaleLinear().rangeRound([height, 0]);
        this.barY = d3.scaleLinear().rangeRound([0, (height / 2)]);

        this.render();
        this.updateSizes();
        this.canvas = d3.select('#' + this.selector).select('svg');

        registry[this.selector] = this;
    }

    render() {
        const chart = d3.select('#' + this.selector);
        this.chart = chart;
        const svg = chart.select('svg');
        const padder = svg.append('g')
            .attr('class', 'js-padder')
            .attr('transform', 'translate(' + this.padding.left + ', ' + this.padding.top + ')');
        const chartGroup = padder.append('g').attr('class', 'js-chart');
        const indicatorGroup = padder.append('g').attr('class', 'js-indicators');
        const axisGroup = padder.append('g').attr('class', 'js-axis');
        const maskGroup = padder.append('g').attr('class', 'js-mask');

        // axes
        this.axisX = axisGroup.append('g')
            .attr("transform", "translate(0," + this.height + ")")
            .attr('class', 'axis x');
        this.axisY = axisGroup.append('g').attr('class', 'axis y');

        // charts
        const barChart = chartGroup.append('g').attr('class', 'js-bar-chart')
            .attr('transform', 'translate(0, ' + this.height + ')');
        const lineChart = chartGroup.append('g').attr('class', 'js-line-chart');
        const path = lineChart.append('path').attr('class', 'js-line-path');
        const pathref = lineChart.append('path').attr('class', 'js-line-pathref');

        // mask
        const dispatch = (name, data) => { this.dispatchEvent(name, data) };

        const getCoords = (event) => {
            const coords = d3.mouse(this.dom);
            
            return {
                x: coords[0] - (this.padding.left * this.zoomRatio),
                y: coords[1] - this.padding.top
            }
        };

        const onMouseMove = function() {
            dispatch('mouseMove', getCoords(this));
        };

        const onMouseLeave = function() {
            dispatch('mouseLeave');
        };

        const onMouseEnter = function() {
            dispatch('mouseEnter');
        };

        const onMouseUp = function() {
            maskGroup.attr('class', null);
            dispatch('mouseUp', getCoords(this));
        };

        const onMouseDown = function() {
            maskGroup.attr('class', 'dragging');
            dispatch('mouseDown', getCoords(this));
        };

        const onDoubleClick = function() {
            dispatch('doubleClick');
        };

        maskGroup.append('rect')
            .attr('width', this.width)
            .attr('height', this.height)
            .attr('fill', 'transparent')
            .attr('class', 'js-mask')
            .on('mousemove', onMouseMove)
            .on('touchmove', onMouseMove)
            .on('mouseenter', onMouseEnter)
            .on('mouseleave', onMouseLeave)
            .on('mousedown', onMouseDown)
            .on('touchstart', onMouseDown)
            .on('dblclick', onDoubleClick)
        ;

        d3.select('body')
            .on('mouseup.' + this.selector, onMouseUp)
            .on('touchend.' + this.selector, onMouseUp);
    }

    reset() {
        // TODO reset line
        this.applyData(this.data);
    }

    initializeShow() {
        this.dom.classList.add('initialized');
    }

    applyData(data) {
        if (this.initialized === false) {
            this.initialized = true;
            this.initializeShow();
        }
        this.data = data;
        this.scopedData = data;

        this.updateAxis(data);
        this.updateCharts(data, true);

        this.updateDimensions();
    }

    updateAxis(data) {
        const max = d3.max(data, d => d.line);
        const min = d3.min(data, d => d.line);
        const diff = Math.abs(min - max);
        const offset = diff * .25;

        this.x.domain([0, data.length-1]);
        this.y.domain([
            d3.min(data, d => d.line) - offset,
            d3.max(data, d => d.line) + offset
        ]);
        this.barY.domain([0, d3.max(data, d => d.bar)]);

        const periodName = $(this.dom).siblings('.visualization__meta').find('.js-current').attr('data-period');
        const getType = $(this.dom).attr('data-type');
        var ticksArray = [];
        var dailyTicks = [];

        if (periodName == '7days') {
            if (getType == 'forex') {
                const firstTick = Math.floor(data.length / 3);
                const secondTick = firstTick * 2;
                ticksArray = [0, firstTick, secondTick, data.length - 1];
            } else { // for Example Commodities
                var i;
                for(i=0; i < data.length; i++) {
                    dailyTicks.push(i);
                }
                ticksArray = dailyTicks;
            }
        } else if (periodName == '3months' || periodName == '3years') {
            const firstTick = Math.floor(data.length / 3);
            const secondTick = firstTick * 2;
            ticksArray = [0, firstTick, secondTick, data.length - 1];
        } else if (periodName == 'month' || periodName == '12months') {
            const firstTick = Math.floor(data.length / 4);
            const secondTick = firstTick * 2;
            const thirdTick = secondTick + firstTick;
            ticksArray = [0, firstTick, secondTick, thirdTick, data.length - 1];
        } else if (periodName == '5years') {
            const firstTick = Math.floor(data.length / 5);
            const secondTick = firstTick * 2;
            const thirdTick = secondTick + firstTick;
            const fourthTick = thirdTick + firstTick;
            ticksArray = [0, firstTick, secondTick, thirdTick, fourthTick, data.length - 1];
        } else {
            const firstTick = Math.floor(data.length / 3);
            const secondTick = firstTick * 2;
            ticksArray = [0, firstTick, secondTick, data.length - 1];
        }

        this.getAxes(data, periodName, getType, ticksArray);
    }

    getAxes(data, periodName, getType, ticksArray) {
        this.axisX.call(
            d3.axisBottom(this.x)
                .tickValues(ticksArray)
                .tickFormat((index) => data[index].hint.data)
        );
        this.axisY.call(d3.axisLeft(this.y).ticks(4));
    }

    updateCharts(data, force) {
        this.updateLineChart(data, force);
        this.updateBarChart(data, force);
    }

    updateLineChart(data, force) {
        const x = this.x;
        const y = this.y;

        const line = d3.line()
            .x((d, i) => x(i))
            .y(d => y(d.line));

        const baseLine = data.map(() => data[0]);

        const path = this.chart.select('.js-line-path');
        const pathref = this.chart.select('.js-line-pathref');

        if (force) {
            path.attr('d', line(baseLine));
        }

        path.transition().duration(800).attr("fill", "none").attr("stroke", "#75171D").attr("stroke-linejoin", "round").attr("stroke-linecap", "round").attr("stroke-width", 2.5).attr("d", line(data));
        pathref.transition().duration(800).attr("fill", "none").attr("stroke", "#75171D").attr("stroke-linejoin", "round").attr("stroke-dasharray", "10, 5").attr("stroke-linecap", "round").attr("stroke-width", 0.5).attr("d", line(baseLine));
    }

    updateBarChart(data, force) {
        const barY = this.barY;
        const width = this.width;
        const segmentWidth = () => width / data.length;

        const bars = this.chart.select('.js-bar-chart')
            .selectAll('rect')
            .data(data);

        bars.exit()
            .transition()
            .duration(800)
            .attr('height', 0)
            .attr('transform', 'translate(0, 0)')
            .remove();

        bars.enter()
            .append('rect')
            .attr('x', (d, i) => i * segmentWidth())
            .attr('width', segmentWidth())
            .attr('fill', '#efe8e8')
            .attr('class', 'chart__bar')
            .transition()
            .duration(800)
            .attr('height', d => barY(d.bar))
            .attr('transform', d => 'translate(0, -' + barY(d.bar) + ')')
        ;

        bars.transition()
            .duration(800)
            .attr('width', segmentWidth())
            .attr('height', d => barY(d.bar))
            .attr('transform', d => 'translate(0, -' + barY(d.bar) + ')')
            .attr('x', (d, i) => i * segmentWidth());
    }

    addPlugin(plugin) {
        this.plugins.push(plugin);

        plugin['setParent'] && plugin.setParent(this);
        plugin['init'] && plugin.init();
    }

    narrow(from, to) {
        this.scopedData = this.scopedData.slice(from, to);
        this.updateCharts(this.scopedData, false);
    }

    dom() {
        return this.dom;
    }

    updateSizes() {
        var width = this.width + (this.padding.left + this.padding.right);
        var height = this.height + (this.padding.top + this.padding.bottom);
        this.svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    }

    dispatchEvent(name, data) {
        const methodName = 'on' + name.charAt(0).toUpperCase() + name.slice(1);

        this.plugins
            .filter(plugin => 'undefined' !== typeof plugin[methodName])
            .forEach(plugin => plugin[methodName](data));
    }

    static getChart(id) {
        return registry[id];
    }

    updateDimensions() {
        this.chartRwdWidth = $(this.dom).find('.js-chart')[0].getBoundingClientRect().width;
        this.zoomRatio = this.chartRwdWidth / this.width;
    }
}

Chart.registry = {};


// WEBPACK FOOTER //
// ./js/Model/Chart.js